import { FC } from "react";
import { Button, HStack, Text, useToast } from "@chakra-ui/react";

import { CopyIcon } from "../../../icons";

interface Props {
  id: string | undefined;
  bgColor: string;
}

export const ErrorTechInfoId: FC<Props> = ({ id, bgColor }) => {
  const toast = useToast();

  const onCopy = async () => {
    if (id) {
      await navigator.clipboard.writeText(id);

      toast({
        id: "text-copied",
        description: "Скопировано",
      });
    }
  };

  if (!id) {
    return null;
  }

  return (
    <HStack
      spacing={0}
      py="6px"
      px="10px"
      borderRadius="12px"
      bgColor={bgColor}
    >
      <Text fontSize="14px" mr="11px">ID</Text>
      <Text variant="brand">{id}</Text>

      <Button
        minW="20px"
        h="20px"
        p="0"
        ml="4px"
        colorScheme="transparent"
        onClick={onCopy}
      >
        <CopyIcon />
      </Button>
    </HStack>
  );
};
